module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-solid-811ddfb022099fc55dab92b1e5d635e2.svg";